module.exports = __webpack_public_path__ + "static/img/location-outline.5259dfbe.svg";